(function () {
  'use strict';

  function getProductTabs() {
    return document.querySelector('.product_tab-section .product-tabs');
  }

  function activateTab(tabsContainer, tabName) {
    if (!tabsContainer) return false;

    var tabContents = tabsContainer.querySelectorAll('.tab-content');
    var tabButtons = tabsContainer.querySelectorAll('.tab-button');
    var selectedContent = tabsContainer.querySelector('#' + tabName);
    var selectedButton = null;

    tabButtons.forEach(function (button) {
      button.classList.remove('active');

      var buttonText = (button.textContent || '').trim().toLowerCase();

      if (
        buttonText === tabName.toLowerCase() ||
        button.getAttribute('data-tab') === tabName
      ) {
        selectedButton = button;
      }
    });

    tabContents.forEach(function (content) {
      content.classList.remove('active');
    });

    if (!selectedContent) return false;

    selectedContent.classList.add('active');

    if (selectedButton) {
      selectedButton.classList.add('active');
    }

    return true;
  }

  /*
   * Keep this function global because the Liquid buttons currently call:
   * onclick="openTab(event, 'reviews')"
   */
  window.openTab = function (event, tabName) {
  if (event) {
    event.preventDefault();
  }

  var clickedButton = event && event.currentTarget
    ? event.currentTarget
    : null;

  var tabsContainer = clickedButton
    ? clickedButton.closest('.product-tabs')
    : getProductTabs();

  if (!tabsContainer) return;

  tabsContainer.querySelectorAll('.tab-button').forEach(function (button) {
    button.classList.remove('active');
    button.setAttribute('aria-selected', 'false');
  });

  tabsContainer.querySelectorAll('.tab-content').forEach(function (content) {
    content.classList.remove('active');
  });

  var selectedContent = tabsContainer.querySelector('#' + tabName);

  if (selectedContent) {
    selectedContent.classList.add('active');
  }

  if (clickedButton) {
    clickedButton.classList.add('active');
    clickedButton.setAttribute('aria-selected', 'true');
  }

  /*
   * Remove the Judge.me review anchor after leaving the Reviews tab.
   * This prevents the review hash from interfering with another selected tab.
   */
  if (
    tabName !== 'reviews' &&
    (
      window.location.hash === '#reviews' ||
      window.location.hash === '#judgeme_product_reviews'
    )
  ) {
    window.history.replaceState(
      null,
      document.title,
      window.location.pathname + window.location.search
    );
  }
};

  function openReviewsAndScroll() {
    var tabsContainer = getProductTabs();

    if (!tabsContainer) return;

    var opened = activateTab(tabsContainer, 'reviews');

    if (!opened) return;

    /*
     * Give the hidden review content time to enter the page layout before
     * calculating its scroll position.
     */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var reviewsButton = Array.prototype.find.call(
          tabsContainer.querySelectorAll('.tab-button'),
          function (button) {
            return (button.textContent || '').trim().toLowerCase() === 'reviews';
          }
        );

        var scrollTarget =
          reviewsButton ||
          tabsContainer.querySelector('#reviews') ||
          tabsContainer;

        var stickyOffset = 120;
        var targetTop =
          scrollTarget.getBoundingClientRect().top +
          window.pageYOffset -
          stickyOffset;

        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: 'smooth'
        });

        window.setTimeout(function () {
          window.dispatchEvent(new Event('resize'));
        }, 150);
      });
    });
  }

  function getEventPath(event) {
    if (typeof event.composedPath === 'function') {
      return event.composedPath();
    }

    var path = [];
    var node = event.target;

    while (node) {
      path.push(node);
      node = node.parentNode;
    }

    return path;
  }

  function isJudgeMeReviewTrigger(event) {
    var path = getEventPath(event);

    for (var i = 0; i < path.length; i += 1) {
      var element = path[i];

      if (!element || element.nodeType !== 1) continue;

      if (
        element.matches &&
        element.matches(
          [
            '.jdgm-prev-badge',
            '.jdgm-prev-badge__stars',
            '.jdgm-prev-badge__text',
            '.jdgm-star',
            '.jdgm-all-reviews-text',
            '[data-jdgm-preview-badge]',
            'a[href="#judgeme_product_reviews"]',
            'a[href="#reviews"]'
          ].join(',')
        )
      ) {
        return true;
      }

      var parentTrigger =
        element.closest &&
        element.closest(
          [
            '.jdgm-prev-badge',
            '[data-jdgm-preview-badge]',
            'a[href="#judgeme_product_reviews"]',
            'a[href="#reviews"]'
          ].join(',')
        );

      if (parentTrigger) {
        return true;
      }
    }

    return false;
  }

  /*
   * Capture phase is intentional. Judge.me can handle the click before a
   * normal bubbling listener receives it.
   */
  document.addEventListener(
    'click',
    function (event) {
      if (!isJudgeMeReviewTrigger(event)) return;

      openReviewsAndScroll();
    },
    true
  );

  /*
   * Also support direct links and Judge.me changing the page hash.
   */
  function handleReviewHash() {
    if (
      window.location.hash === '#reviews' ||
      window.location.hash === '#judgeme_product_reviews'
    ) {
      openReviewsAndScroll();
    }
  }

  window.addEventListener('hashchange', handleReviewHash);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleReviewHash);
  } else {
    handleReviewHash();
  }
})();